import { InvestmentCountOption, PlanCode } from '@inversor-hub/types';

export type UpgradeWallInvestmentCount = '1' | '2-3' | '4-6' | '6+' | null;
export type UpgradeWallRecommendedPlan = 'inversor' | 'patrimonio' | null;

export const mapInvestmentCountToUpgradeWallCount = (
  value?: InvestmentCountOption | null
): UpgradeWallInvestmentCount => {
  switch (value) {
    case 'ONE':
      return '1';
    case 'TWO_TO_THREE':
      return '2-3';
    case 'FOUR_TO_SIX':
      return '4-6';
    case 'MORE_THAN_SIX':
      return '6+';
    default:
      return null;
  }
};

export const getUpgradeWallRecommendedPlan = (
  investmentCount: UpgradeWallInvestmentCount
): UpgradeWallRecommendedPlan => {
  if (investmentCount === '6+') {
    return 'patrimonio';
  }

  if (investmentCount === null) {
    return null;
  }

  return 'inversor';
};

export const getUpgradeWallValueHeading = (investmentCount: UpgradeWallInvestmentCount) => {
  const recommendedPlan = getUpgradeWallRecommendedPlan(investmentCount);

  if (recommendedPlan === 'patrimonio') {
    return 'Con un plan Patrimonio puedes:';
  }

  if (recommendedPlan === 'inversor') {
    return 'Con un plan Inversor puedes:';
  }

  return 'Con un plan de pago puedes:';
};

export const getUpgradeWallBannerText = (
  investmentCount: UpgradeWallInvestmentCount
): string | null => {
  switch (investmentCount) {
    case '1':
      return 'Ya tienes tu primera inversión registrada. El plan Inversor te permite añadir hasta 6.';
    case '2-3':
      return 'Nos has contado que gestionas 2-3 inversiones. El plan Inversor cubre hasta 6.';
    case '4-6':
      return 'Nos has contado que gestionas 4-6 inversiones. El plan Inversor cubre hasta 6.';
    case '6+':
      return 'Nos has contado que gestionas más de 6 inversiones. Con el plan Patrimonio las gestionas todas sin límite.';
    default:
      return null;
  }
};

export const buildUpgradeWallPlansPath = (investmentCount: UpgradeWallInvestmentCount) => {
  const params = new URLSearchParams();
  const recommendedPlan = getUpgradeWallRecommendedPlan(investmentCount);

  if (recommendedPlan) {
    params.set('recommended', recommendedPlan);
  }

  const queryString = params.toString();
  return queryString ? `/planes?${queryString}` : '/planes';
};

export const getRecommendedPlanCodeFromQuery = (
  recommendedPlan: string | null
): PlanCode | null => {
  if (recommendedPlan === 'inversor') {
    return 'INVERSOR';
  }

  if (recommendedPlan === 'patrimonio') {
    return 'PORTFOLIO';
  }

  return null;
};
